import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import { auth } from "../firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    props: { showReg: true }
  },
  {
    path: "/getting-started",
    name: "GettingStarted",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/GettingStarted.vue")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/403",
    name: "403",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/permission_denied.vue")
  },
  {
    path: "*",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/page_not_found.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// navigation guard to check for logged in users
// eslint-disable-line no-unused-vars
router.beforeEach((to, from, next) => {
  //console.log(from);
  console.log("to", to);
  console.log("auth user", auth.currentUser);
  if (auth.currentUser && auth.currentUser.details) {
    if (
      (!auth.currentUser.emailVerified ||
        !auth.currentUser.details ||
        !auth.currentUser.details.address ||
        !auth.currentUser.details.languages) &&
      ![
        "/getting-started",
        "/profile",
        "/logout",
        "/login",
        "/403",
        "/404"
      ].includes(to.path)
    ) {
      next("/getting-started");
      return;
    }
  }
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const roles = to.meta.roles || [];
  //console.log("roles", roles);
  if (roles && roles.length > 0) {
    auth.currentUser.getIdTokenResult().then(tokenResult => {
      //console.log(tokenResult.claims);
      for (const index in roles) {
        const role = roles[index];
        console.log("router() has_role", role in tokenResult.claims);
        if ("admin" in tokenResult.claims || role in tokenResult.claims) {
          next();
          return;
        }
      }
      next("/403");
      return;
    });
  } else {
    if (requiresAuth && !auth.currentUser) {
      next("/login");
      return;
    } else {
      next();
      return;
    }
  }
});

export default router;
